import { cellText, normalizeHeader } from '@/lib/daily-reports/cells';

/** True when a header cell contains `needle` after AS/400-style normalization. */
export function headerContains(value: unknown, needle: string): boolean {
  return normalizeHeader(value).includes(normalizeHeader(needle));
}

export function rowHasHeader(row: unknown[], needle: string): boolean {
  return row.some((cell) => headerContains(cell, needle));
}

export function columnIndex(row: unknown[], needle: string): number {
  const wanted = normalizeHeader(needle);
  const exact = row.findIndex((cell) => normalizeHeader(cell) === wanted);
  if (exact >= 0) return exact;
  return row.findIndex((cell) => headerContains(cell, needle));
}

export function findHeaderRowIndex(rows: unknown[][], needle: string): number {
  return rows.findIndex((row) => rowHasHeader(row, needle));
}

export function isDescriptionFrHeader(value: unknown): boolean {
  const name = normalizeHeader(value);
  return (
    name.includes('DESCRIPTION-FR') ||
    name.includes('DESCRIPTION/FR') ||
    name.includes('DESCRIPTION FR')
  );
}

export function isEnglishDescriptionHeader(value: unknown): boolean {
  const name = normalizeHeader(value);
  if (!name.includes('DESCRIPTION')) return false;
  if (isDescriptionFrHeader(value)) return false;
  return !name.includes('PRICE LIST');
}

export function uniqueJoined(values: Iterable<string>): string {
  return [
    ...new Set([...values].map((value) => cellText(value)).filter(Boolean)),
  ]
    .sort((left, right) => left.localeCompare(right))
    .join('; ');
}
